module.exports = __webpack_public_path__ + "img/blueTooth.21d54b20.png";